import './Collapse.css';
import React, { useRef } from 'react';
import useCollapse from './useCollapse';

export default function Collapse({ isOpen = false, ...rest }: any) {
  const content = useRef(null);
  const { setIsExpandedStyle, setIsCollapsedStyle, style } = useCollapse({
    isOpen,
    content,
  });

  const onTransitionEnd = (e: any) => {
    if (e.target === content.current && e.propertyName === 'height') {
      if (isOpen) {
        setIsExpandedStyle();
      } else {
        setIsCollapsedStyle();
      }
    }
  };

  const styles = {
    willChange: 'height',
    ...style,
  };

  return (
    <div
      ref={content}
      style={styles}
      className='Collapse'
      onTransitionEnd={onTransitionEnd}
      {...rest}
    />
  );
}